import { render, staticRenderFns } from "./AddManualPayment.vue?vue&type=template&id=24a84186&scoped=true&"
import script from "./AddManualPayment.vue?vue&type=script&lang=js&"
export * from "./AddManualPayment.vue?vue&type=script&lang=js&"
import style0 from "./AddManualPayment.vue?vue&type=style&index=0&id=24a84186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a84186",
  null
  
)

component.options.__file = "AddManualPayment.vue"
export default component.exports